import { Users } from 'lucide-react';
import type { NavigationItem } from '@/shared/types/navigation';

export const charactersNavItems: NavigationItem[] = [
  {
    id: 'characters',
    category: 'tool',
    name: 'characters.name',
    description: 'characters.description',
    icon: Users,
    href: '/characters',
  },
];
